<dialog-wrapper
    [backgroundColor]="'#41474f'"
    [dialogTitle]="'Share Revenue Settings'"
    [smallTitle]="true"
    [titleHeight]="40"
    [giveMeTwenty]="true"
    [maxHeight]="maxHeight"
    [disabled]="false"
    [successLabel]="'Save and View'"
    [tiny]="true"
    [showClose]="true"
    [cancelLeft]="true"
    (cancel)="dialogRef.close()"
    (submit)="dialogRef.close(data)"
    (close)="dialogRef.close()">
  <tip-text [type]="'tip'" [head]="'Tip:'" [body]="'Sharing the Revenue Budget will automatically update the live budget to a new version.'"></tip-text>

  <div class="version"><strong>Version {{ data.version }}</strong></div>
  <mat-radio-group name="detail" class="detail-select" [(ngModel)]="data.detailedView" required>
    <mat-radio-button [value]="false">Summary</mat-radio-button>
    <mat-radio-button [value]="true">Detailed</mat-radio-button>
  </mat-radio-group>
  <toggle-tab [borderless]="true" [text]="'Show payment schedule'" [toggled]="!data.hidePaymentSchedule" (toggle)="data.hidePaymentSchedule = !data.hidePaymentSchedule" [addSpacer]="true"></toggle-tab>
  <toggle-tab [borderless]="true" [text]="'Show file links'" [toggled]="!data.hideFileLinks" (toggle)="data.hideFileLinks = !data.hideFileLinks" [addSpacer]="true"></toggle-tab>
  <toggle-tab [borderless]="true" [text]="'Show in another currency'" [toggled]="!!data.showInAnotherCurrency" (toggle)="data.showInAnotherCurrency = !data.showInAnotherCurrency" [addSpacer]="true"></toggle-tab>
  <ng-container *ngIf="!!data.showInAnotherCurrency">
    <div class="line-holder">
      <div class="line-label" >Budget Currency:</div>
      <div style="flex:1;"></div>
      <div><strong>{{ data.budgetCurrency }}</strong></div>
    </div>
    <div class="line-holder">
      <div class="line-label" >Share Currency:</div>
      <div style="flex:1;"></div>
      <dropdown 
        [showSearch]="true"
        [selections]="currencyOptions"
        [selected]="currencyOptions | findById:data.currencyId" 
        [null_text]="'Select'"
        (select)="updateCurrency($event.id)"
      ></dropdown>
    </div>
    <div class="line-holder">
      <div class="conversion-label">Conversion Rate: </div>
      <div style="flex:1;"></div>
      <joi-input class="conversion-rate"
        [(model)]="data.conversionRate" 
        [fixedWidth]="true"
        [placeholder]="'Conversion rate'"
        [allowableCharacters]="'0123456789.'"
        (joiChange)="updateConversionRate()"
      ></joi-input>
    </div>
  </ng-container>

</dialog-wrapper>